import React from "react";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";
import "./Educations.css";

function Educations(props) {
  const theme = props.theme;
  const { lang } = useLanguage();
  const t = translations[lang].education;

  return (
    <div className="main" id="educations">
      <div className="educations-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="educations-header" style={{ color: theme.text }}>
            {t.qualificationHeader}
          </h1>
        </Fade>
      </div>
      <div className="educations-body-div">
        {degrees.degrees.map((degree, index) => {
          const localized = t.degrees?.[index];
          const displayDegree = localized
            ? { ...degree, ...localized }
            : degree;
          return (
            <DegreeCard
              key={"degree-" + index}
              degree={displayDegree}
              theme={theme}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Educations;
